import React from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import _ from 'lodash';

import dateUtils, { getWorkMinutesPerDay, MINUTES_PER_DAY } from '../../../util/dates';
import dataUtils from '../../../util/dataUtils';
import highchartFactory from '../../../util/highcharts';
import chartUtils from '../../../util/chartUtils';
const highchartUtils = highchartFactory(Highcharts);

const chartConfig = {
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  chart: {
    backgroundColor: '#fff',
    type: 'column',
    events: {
      render: function () {
        chartUtils.roundTops(this);
      },
    },
  },
  title: {
    text: '',
  },
  xAxis: {
    type: 'datetime',
    ordinal: false,
    lineColor: chartUtils.TREND_AXIS_LINE_COLOR,
    tickColor: chartUtils.TREND_AXIS_LINE_COLOR,
    labels: {
      style: {
        color: chartUtils.TREND_LABEL_COLOR,
        fontSize: '12px',
      },
    },
    tickmarkPlacement: 'on',
    title: {
      enable: false,
    },
  },
  yAxis: {
    opposite: false,
    allowDecimals: false,
    labels: {
      style: {
        color: chartUtils.TREND_LABEL_COLOR,
        fontSize: '12px',
        whiteSpace: 'nowrap',
      },
      formatter: function () {
        return chartUtils.withUnit(Math.ceil(this.value / MINUTES_PER_DAY), 'day');
      },
    },
    min: 0,
    gridLineColor: chartUtils.TREND_GRID_COLOR,
    gridLineWidth: 1,
    title: {
      enabled: false,
    },
  },
  legend: {
    enabled: false,
  },
  tooltip: {
    enabled: false,
  },
  plotOptions: {
    series: {
      stickyTracking: false,
    },
    column: {
      stacking: 'normal',
      pointPadding: 0.08,
      borderWidth: 1,
      groupPadding: 0.04,
      shadow: false,
      pointRange: 7 * 24 * 3600 * 1000,
      inactiveOtherPoints: true,
      states: chartUtils.BAR_STATES,
    },
  },
  series: [
    {
      name: 'Data',
      data: [],
    },
  ],
};

class CTBChart extends React.Component {
  componentDidMount() {
    this.chart = new Highcharts['Chart'](`${this.props.id}-details`, chartConfig);

    this.updateTimeLabelsFormat(this.props.dateFormat);
    this.updateYAxisFormatter();

    if (this.props.data) {
      this.updateChart();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.updateChart();
    }

    if (prevProps.dateFormat != this.props.dateFormat) {
      this.updateTimeLabelsFormat(this.props.dateFormat);
    }

    if (prevProps.excludeWeekendOpts !== this.props.excludeWeekendOpts) {
      this.updateYAxisFormatter();
    }
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  updateChart() {
    while (this.chart.series.length > 0) {
      this.chart.series[0].remove(false);
    }
    const series = chartUtils.stateSeries(this.props.data, 'borderColor');
    for (let i = 0; i < this.props.data.length; i++) {
      this.chart.addSeries(series[i], false);
    }

    this.chart.redraw();
  }

  updateTimeLabelsFormat(dateFormat) {
    let config = { xAxis: {} };
    config.xAxis.dateTimeLabelFormats = dateUtils.createHighchartFormats(dateFormat);

    this.chart.update(config);
  }

  updateYAxisFormatter() {
    const workMinutesPerDay = getWorkMinutesPerDay(this.props.excludeWeekendOpts, this.props.useWorkingHoursInCycleTimeDays);
    this.chart.update({
      yAxis: {
        labels: {
          formatter: function() {
            return chartUtils.withUnit(Math.ceil(this.value / workMinutesPerDay), 'day');
          }
        }
      }
    });
  }

  render() {
    return (
      <div id={this.props.id} className={this.props.className}>
        <div>
          <div id={`${this.props.id}-details`}></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dateFormat: state.filters.dateFormat,
    timeUnit: state.filters.ctb.timeUnit,
    excludeWeekendOpts: {
      type: state.filters.excludeWeekends,
      workStart: state.filters.workStart,
      workEnd: state.filters.workEnd,
      holidays: state.filters.holidays
    },
    useWorkingHoursInCycleTimeDays: state.auth.user.config && state.auth.user.config.useWorkingHoursInCycleTimeDays
  };
};

export default connect(mapStateToProps)(CTBChart);
